module.exports = __webpack_public_path__ + "img/Wischenbart Manfred.jpg";